import { pluralize } from '../pluralize';
import { BONUS_FORMS, BONUS_FORMS_WITH_COUNT } from './constants';

export function formatBonusWord(count: number): string {
    return pluralize(count, ...BONUS_FORMS);
}

export function formatBonusWithCount(count: number): string {
    return pluralize(count, ...BONUS_FORMS_WITH_COUNT);
}
